/**
 * Escapes characters that can not be in an XML attribute.
 */
export function escapeAttribute(value: string): string {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}



// WEBPACK FOOTER //
// ../escape-attribute.ts